var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"last-step"},[_c('div',{staticClass:"clap-container"},[_c('img',{attrs:{"src":_vm.clapIcon}})]),_c('h1',[_vm._v("Aula avaliada com sucesso!")]),_c('p',[_vm._v(" Obrigada pelo seu feedback! ")]),_c('button',{on:{"click":_vm.backToFirstStep}},[_vm._v("Refazer")])])
}
var staticRenderFns = []

export { render, staticRenderFns }